import { sortBy, prop } from 'ramda'

export default sortBy(prop('title'))



// WEBPACK FOOTER //
// ./src/utils/sortByTitle.js